var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 8,
    transform: "matrix(-1 0 0 1 38 0)",
    fill: "#E9E9EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.491 10.667H15.5077C12.4743 10.667 10.666 12.4753 10.666 15.5087V22.4837C10.666 25.5253 12.4743 27.3337 15.5077 27.3337H22.4827C25.516 27.3337 27.3243 25.5253 27.3243 22.492V15.5087C27.3327 12.4753 25.5243 10.667 22.491 10.667ZM18.1243 23.592C17.8827 23.8337 17.4243 24.067 17.091 24.117L15.041 24.4087C14.966 24.417 14.891 24.4253 14.816 24.4253C14.4743 24.4253 14.1577 24.3087 13.9327 24.0837C13.6577 23.8087 13.541 23.4087 13.6077 22.967L13.8993 20.917C13.9493 20.5753 14.1743 20.1253 14.4243 19.8837L18.141 16.167C18.2077 16.342 18.2743 16.517 18.366 16.717C18.4493 16.892 18.541 17.0753 18.641 17.242C18.7243 17.3837 18.816 17.517 18.891 17.617C18.9827 17.7587 19.091 17.892 19.1577 17.967C19.1993 18.0253 19.2327 18.067 19.2493 18.0837C19.4577 18.3337 19.6993 18.567 19.9077 18.742C19.966 18.8003 19.9993 18.8337 20.016 18.842C20.141 18.942 20.266 19.042 20.3743 19.117C20.5077 19.217 20.641 19.3087 20.7827 19.3837C20.9493 19.4837 21.1327 19.5753 21.316 19.667C21.5077 19.7503 21.6827 19.8253 21.8577 19.8837L18.1243 23.592ZM23.4743 18.242L22.7077 19.017C22.6577 19.067 22.591 19.092 22.5243 19.092C22.4993 19.092 22.466 19.092 22.4493 19.0837C20.7577 18.6003 19.4077 17.2503 18.9243 15.5587C18.8993 15.467 18.9243 15.367 18.991 15.3087L19.766 14.5337C21.0327 13.267 22.241 13.292 23.4827 14.5337C24.116 15.167 24.4243 15.7753 24.4243 16.4087C24.416 17.0087 24.1077 17.6087 23.4743 18.242Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.1adf1fe4f813f5df438c94941fb0b815.svg";
export { ForwardRef as ReactComponent };